import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon, ChevronRightIcon } from 'lucide-react';
export function CalendarReminder() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2842">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2843">
        <div className="flex items-center gap-4 p-6 rounded-xl shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-2844">
          <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
          color: '#c8a84b'
        }} data-id="element-2845" />
          <div className="flex-1" data-id="element-2846">
            <p className="text-sm mb-1" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2847">
              Before you visit, always check for closures:
            </p>
            <Link to="/Calendar.html" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2848">
              View the Club Calendar
            </Link>
          </div>
          <ChevronRightIcon size={20} className="flex-shrink-0" style={{
          color: '#a0c8b0'
        }} data-id="element-2849" />
        </div>
      </div>
    </div>;
}